import { func, number } from 'prop-types'
import { renderIcon, WithTooltip, kuiperClassNames } from '@opallabs/kuiper'

export const StampManagerActions = ({
  entityId,
  onDeleteStamp,
  onViewStamp,
}) => (
  /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
  <div className={kuiperClassNames('stamp-actions')}>
    <div
      className={kuiperClassNames('stamp-action-view')}
      onClick={() => onViewStamp(entityId)}
    >
      <WithTooltip content="View Stamp" tooltipOptions={{ position: 'top' }}>
        {renderIcon('eye', {
          style: { height: 14, width: 14 },
          ariaLabel: 'View stamp',
          ariaMode: 'presentational',
        })}
      </WithTooltip>
    </div>
    <div
      className={kuiperClassNames('stamp-action-delete')}
      onClick={() => onDeleteStamp(entityId)}
    >
      <WithTooltip content="Delete Stamp" tooltipOptions={{ position: 'top' }}>
        {renderIcon('delete', {
          style: { height: 14, width: 14 },
          ariaLabel: 'Delete stamp',
          ariaMode: 'presentational',
        })}
      </WithTooltip>
    </div>
  </div>
  /* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
)

StampManagerActions.propTypes = {
  entityId: number,
  onDeleteStamp: func,
  onViewStamp: func,
}
